// IE10 polyfill console.group etc:
// Note this must happen before any code attempt to write to console.
if (window.console && !console.group) {
  console.log('Stubbing console.group for IE10 etc');
  // eslint-disable-next-line no-multi-assign
  console.group = console.groupCollapsed = console.groupEnd = console.log;
}
